import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectCountryPage } from './select-country.page';

const routes: Routes = [
  {
    path: '',
    component: SelectCountryPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectCountryPageRoutingModule {}
